import { SectionHeading } from './SectionHeading'

const FIELDS = [
  {
    image: '/images/financial_app_1.png',
    title: 'スマートフォンアプリ開発',
    description:
      'iOS（Swift/Objective-C）、Android OS（Java/Kotlin）のネイティブコードでのアプリ開発。Unityプラットフォームでの開発。ゲームやエンタメ系に限らず、金融取引やポイントアプリ等の実用アプリの開発も得意。特にUnity開発は両OSを１つのコードで開発するため、保守運用を含めて安価な開発が可能です。',
    tags: ['iOS', 'Android', 'Unity']
  },
  {
    image: '/images/web_system_1.png',
    title: 'WEBシステム/サービス開発',
    description:
      'データベース設計を含むWEBシステムの構築、クラウドでのインフラ構築・運用が可能です。WEBはHTML5とJavaScriptによるアプリケーションの構築を得意としています。',
    tags: ['React', 'Node.js', 'AWS']
  },
  {
    image: '/images/homepage.png',
    title: 'ホームページ制作',
    description:
      'コーポレートサイト、サービスサイト、ランディングページなど、デザインから実装・公開・運用まで一貫して対応します。レスポンシブデザイン、SEO対策、CMS（WordPress等）導入、アクセス解析の連携まで、ビジネスの成果につながるホームページをご提供します。',
    tags: ['WordPress', 'レスポンシブ', 'SEO'],
    link: {
      url: 'https://jfrontier.net/design-sample/',
      label: 'デザインサンプルを見る'
    }
  },
  {
    image: '/images/financial_app_2.png',
    title: 'Fintechソリューション開発',
    description:
      'QRコード決済システム（トークン決済を含む）を実装したスマホ／PC-WEBシステムの構築が可能です。また、デジタルトークンを利用しブロックチェーンに接続するWEBサービス、エンタメ系サービスの開発なども行います。',
    tags: ['FinTech', 'Blockchain', 'QR決済']
  },
  {
    image: '/images/ar_vr_system_1.png',
    title: 'VR/AR開発',
    description:
      'Unityプラットフォーム上で動作する、VRやARのコンテンツ（ゲーム/実用を問わず）の開発ができます。',
    tags: ['Unity', 'VR', 'AR']
  },
  {
    image: '/images/etc_app_1.png',
    title: 'その他',
    description:
      'ジョルダン株式会社の豊富な開発経験・運用経験、開発資産とリソースを利用したWEBシステム、アプリケーションの開発と運用を行います。',
    tags: ['Jordan Group', 'SI', '運用']
  }
]

const PLATFORMS = [
  {
    name: 'モバイル',
    techs: ['Swift', 'Objective-C', 'Kotlin', 'Java', 'Unity']
  },
  {
    name: 'Web / フロントエンド',
    techs: [
      'HTML5',
      'JavaScript',
      'TypeScript',
      'React',
      'Next.js',
      'Vue.js',
      'WordPress',
      'Strapi'
    ]
  },
  {
    name: 'クラウド / インフラ',
    techs: ['AWS', 'Node.js', 'ホームページ運営']
  },
  {
    name: 'Fintech',
    techs: ['QRコード決済', 'トークン決済', 'ブロックチェーン']
  },
  {
    name: 'VR / AR・IoT',
    techs: ['Unity VR/AR', 'NFC', 'GPS']
  }
]

export function Development() {
  return (
    <section id="development" className="section-wrapper bg-brand-gray">
      <div className="container-inner">
        <SectionHeading subtitle="Development Fields" title="開発分野" />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {FIELDS.map((field, i) => (
            <div
              key={field.title}
              className={`flip-card h-80 animate-on-scroll animate-on-scroll-delay-${(i % 3) + 1}`}
            >
              <div className="flip-card-inner">
                {/* 表: 画像 + タイトル + タグ */}
                <div className="flip-card-front bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-300">
                  <div className="relative overflow-hidden h-44">
                    <img
                      src={field.image}
                      alt={field.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-brand-navy/40" />
                    <div className="absolute inset-x-0 bottom-0 h-[3px] bg-gradient-to-r from-transparent via-brand-cyan to-transparent" />
                  </div>
                  <div className="p-6">
                    <h3 className="font-bold text-brand-navy mb-3">
                      {field.title}
                    </h3>
                    <div className="flex flex-wrap gap-2">
                      {field.tags.map((tag) => (
                        <span
                          key={tag}
                          className="text-xs px-3 py-1 bg-brand-gray text-brand-blue rounded-full border border-brand-blue/20"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                  <span
                    aria-hidden
                    className="absolute bottom-3 right-3 w-7 h-7 rounded-full bg-white/90 border border-brand-cyan/40 text-brand-cyan flex items-center justify-center shadow-sm pointer-events-none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-3.5 h-3.5"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M21 12a9 9 0 1 1-3-6.7L21 8" />
                      <path d="M21 3v5h-5" />
                    </svg>
                  </span>
                </div>

                {/* 裏: 説明文 */}
                <div className="flip-card-back bg-brand-navy rounded-2xl p-6 flex flex-col justify-center">
                  <h3 className="text-white font-bold mb-3">{field.title}</h3>
                  <p className="text-white/80 text-sm leading-relaxed">
                    {field.description}
                  </p>
                  <div className="flex flex-wrap gap-2 mt-4">
                    {field.tags.map((tag) => (
                      <span
                        key={tag}
                        className="text-xs px-3 py-1 bg-white/10 text-white/80 rounded-full border border-white/20"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  {field.link && (
                    <a
                      href={field.link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1.5 mt-4 text-sm font-semibold text-brand-cyan hover:text-white transition-colors w-fit"
                    >
                      {field.link.label}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-3.5 h-3.5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M7 17L17 7" />
                        <path d="M7 7h10v10" />
                      </svg>
                    </a>
                  )}
                  <span className="inline-block mt-4 w-10 h-0.5 bg-brand-cyan rounded-full" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 対応可能な技術 */}
        <div className="animate-on-scroll mt-12 bg-white rounded-2xl shadow-sm p-8">
          <div className="flex items-center gap-3 mb-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5 text-brand-cyan flex-shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
              />
            </svg>
            <h3 className="text-brand-navy font-bold text-lg">
              対応可能な技術
            </h3>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
            {PLATFORMS.map((platform) => (
              <div key={platform.name}>
                <p className="text-brand-cyan text-xs font-semibold mb-2 uppercase tracking-wide">
                  {platform.name}
                </p>
                <div className="flex flex-wrap gap-1.5">
                  {platform.techs.map((tech) => (
                    <span
                      key={tech}
                      className="text-xs px-2.5 py-1 bg-brand-gray text-brand-navy rounded-full border border-slate-200"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="w-full flex align-middle justify-center text-brand-navy mt-8">
            他にも対応可能な技術がございます。お気軽に
            <a href="#contact" className="underline underline-offset-4">
              お問い合わせください。
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
